import { Box, styled } from '@mui/material'

import { hubloTheme } from '@front/theme'

import {
  AppButton,
  type ButtonVariant,
} from '../../inputs/app-button/AppButton'

import { useFooterStyles } from './Footer.styles'

export interface FooterProps {
  onFirstButtonClick: () => void
  onSecondButtonClick?: () => void
  firstLabel: string
  secondLabel?: string
  orientation?: 'horizontal' | 'vertical'
  isFirstButtonDisabled?: boolean
  isSecondButtonDisabled?: boolean
  firstButtonVariant?: ButtonVariant
  secondButtonVariant?: ButtonVariant
  isFirstButtonLoading?: boolean
  isSecondButtonLoading?: boolean
  className?: string
  firstButtonTestId?: string
  secondButtonTestId?: string
}

/** @deprecated use BottomActionBar from design system */

export const FooterContents = ({
  onFirstButtonClick,
  onSecondButtonClick = () => undefined,
  firstLabel,
  secondLabel,
  orientation = 'horizontal',
  isFirstButtonDisabled = false,
  isSecondButtonDisabled = false,
  firstButtonVariant = 'secondary',
  secondButtonVariant = 'primary',
  isFirstButtonLoading = false,
  isSecondButtonLoading = false,
  firstButtonTestId,
  secondButtonTestId,
  className,
}: FooterProps): JSX.Element => {
  const { cx, classes } = useFooterStyles()

  const hasSecondButton = secondLabel && secondLabel.length > 0

  const containerDisplay = orientation === 'horizontal' ? 'flex' : 'block'
  const firstButtonMarginRight =
    orientation === 'horizontal' && hasSecondButton ? 0.5 : 0
  const secondButtonMarginLeft =
    orientation === 'horizontal' && hasSecondButton ? 0.5 : 0
  const firstButtonMarginBottom =
    orientation === 'vertical' && hasSecondButton ? 1 : 0

  return (
    <div className={cx(classes.root, className)}>
      <Box className={classes.container} display={containerDisplay}>
        <Box
          className={classes.fullWidth}
          mr={firstButtonMarginRight}
          mb={firstButtonMarginBottom}
        >
          <AppButton
            variant={firstButtonVariant}
            onClick={onFirstButtonClick}
            fullWidth
            disabled={isFirstButtonDisabled}
            isLoading={isFirstButtonLoading}
            data-testid={firstButtonTestId}
          >
            {firstLabel}
          </AppButton>
        </Box>
        {hasSecondButton && (
          <Box className={classes.fullWidth} ml={secondButtonMarginLeft}>
            <AppButton
              variant={secondButtonVariant}
              onClick={onSecondButtonClick}
              fullWidth
              disabled={isSecondButtonDisabled}
              isLoading={isSecondButtonLoading}
              data-testid={secondButtonTestId}
            >
              {secondLabel}
            </AppButton>
          </Box>
        )}
      </Box>
    </div>
  )
}

export const FooterWithoutBorderTop = FooterContents

export const Footer = styled(FooterContents)`
  border-top: 1px solid ${hubloTheme.palette.tektiteLight.main};
`
